import {adminInfo} from "../../data/adminInfo";
import {studentProfile} from "../../data/studentProfile";
// import * as net from "../../utils/network";
import api from '../../utils/api';
import map from '../../utils/mapdata.js';
import {NotificationManager} from 'react-notifications';
export const ACTION_GET_INFO = 'ACTION_GET_INFO';
export const ACTION_GET_INFO_ABOUT_STUDENT = 'ACTION_GET_INFO_ABOUT_STUDENT';



// function actionAdminInfoLoaded(adminInfo) {
//     return {
//         type: ACTION_GET_INFO,
//         payload: adminInfo
//     };
// }
//
// CREATORS
// export function getInfoForAdmin() {
//     return (dispatch, getState) => {
//         const {core} = getState();
//
//         net.aGet('')
//             .then(data => {
//                 dispatch(actionAdminInfoLoaded(data.filter((adminInfo) => adminInfo === core))); //or any other relevant condition
//             });
//     };
// }

export function getInfoForAdmin() {
    return {
        type:ACTION_GET_INFO,
        payload: adminInfo
    };
}

function retrievedStudent(profile){
    return {
        type: ACTION_GET_INFO_ABOUT_STUDENT,
        payload: profile
    }
}

export function getInfoAboutStudent(id, token) {
    return dispatch => {
        api.getProfile(id, token, res => {
            dispatch(retrievedStudent(res.data));
            dispatch(getCourseUser(res.data.id, token));
        })
    }
}


export function gotSingleCourseUser(cu){
    return {
        type: 'GOT_SINGLE_COURSE_USER',
        payload: cu
    }
}

export function gotCourseUsers(data){
    return {
        type: 'GOT_COURSE_USERS',
        payload: data
    }
}

export function getCourseAndLectures(courseId, token){
    return dispatch => {
        api.getCourseAndLectures(courseId, token, res => {
            dispatch({
                type: 'GOT_COURSE_AND_SUBJECTS',
                payload: res.data
            });
        });
    }
}

export function editedCourseUser(cu){
    return {
        type: 'EDITED_CU',
        payload: cu
    }
}

export function getCompletedSubjects(cuid, token){
    return dispatch => {
        api.getCompletedSubjects(cuid, token, res => {
            dispatch({
                type: 'GOT_COMPLETED_SUBJECTS',
                payload: res.data
            });
        });
    }
}

export function getCompletedUserLectures(usid, token){
    return dispatch => {
        api.getCompletedUserLectures(usid, token, res => {
            dispatch({
                type: 'GOT_COMPLETED_USER_LECTURES',
                payload: res.data
            });
        })
    }
}

export function getSingleCourseUser(profileId, courseId, token){
    return dispatch => {
        if(profileId) {
        api.getSingleCourseUser(profileId, courseId, token, res => {

            if (res.status == 200) {
                // Get Flags:
                api.getAdminFlags(res.data.id, token, res2 => {
                    // console.log("Got flags?", res2);
                    res.data.Flags = res2.data;
                    dispatch(gotSingleCourseUser(res.data));
                })
                
                
            }
        })
        }
    }
}


export function getCourseUser(profileId, token){
    
        return dispatch => {
            if(profileId) {
            api.getAdminCourseUsers(profileId, token, res => {

                if (res.status == 200) {
                    
                    dispatch(gotCourseUsers(res.data));
                }
            })
            }
        }
    
}

export function getVideoQuestions(lectureId, token){
    return dispatch => {
        api.getULVideoQuestions(lectureId, token, res => {
            dispatch({
                type: 'GOT_VIDEO_QUESTIONS',
                payload: res.data
            })
        })
    }
}

export function updatedUserLecture(ul){
    return {
        type: 'UPDATED_USERLECTURE',
        payload: ul
    }
}

export function addedUserLecture(ul){
    return {
        type: 'ADDED_USERLECTURE',
        payload: ul
    }
}

export function removedQuiz(id){
    return {
        type: 'REMOVED_QUIZ',
        payload: id
    }
}

export function removedUserLecture(id){
    return {
        type: 'REMOVED_USERLECTURE',
        payload: id
    }
}

export function getQuizResults(lectureId, token){
    return dispatch => {
        api.getQuizResults(lectureId, token, res => {
            dispatch({
                type: 'GOT_QUIZ_RESULTS',
                payload: res.data
            })
        })
    }
}

export function getLeaderboard(courseIds, skip, limit, token) {
    return dispatch => {
        api.getLeaderboard(courseIds, skip, limit, token, res => {
            dispatch({
                type: 'GOT_LEADERBOARD',
                payload: res.data
            })
        });
    }
}

export function getLeaderboardCount(courseIds, pageSize, token) {
    return dispatch => {
        api.getLeaderboardCount(courseIds, token, res => {
            dispatch({
                type: 'GOT_LEADERBOARD_COUNT',
                payload: Math.ceil(res.data.count / pageSize)
            })
        })
    }
}



export function getDataCount(view, pageSize, token){
    return dispatch => {
        switch(view){
            case 'flags':
                api.getAdminFlagCount(token, res => {
                    // console.log("TC", res.data.count, pageSize);
                    dispatch({
                        type: 'GOT_TABLE_DATA_COUNT',
                        payload: Math.ceil(res.data.count / pageSize)
                    })
                })
                break;
            case 'lecture_failure':
                api.getAdminLectureCount(token, res => {
                    // console.log("TC", res.data.count, pageSize);
                    dispatch({
                        type: 'GOT_TABLE_DATA_COUNT',
                        payload: Math.ceil(res.data.count / pageSize)
                    })
                })
                break;
            case 'subject_failure':
                api.getAdminSubjectCount(token, res => {
                    // console.log("TC", res.data.count, pageSize);
                    dispatch({
                        type: 'GOT_TABLE_DATA_COUNT',
                        payload: Math.ceil(res.data.count / pageSize)
                    })
                })
                break;
            case 'upcoming_tests':
                api.getAdminTestCount(token, res => {
                    // console.log("TC", res.data.count, pageSize);
                    dispatch({
                        type: 'GOT_TABLE_DATA_COUNT',
                        payload: Math.ceil(res.data.count / pageSize)
                    })
                })
                break;
            case 'attendance':
                api.getAdminTestCount(token, res => {
                    // console.log("TC", res.data.count, pageSize);
                    dispatch({
                        type: 'GOT_TABLE_DATA_COUNT',
                        payload: Math.ceil(res.data.count / pageSize)
                    })
                })
                break;
            case 'quiz_average':
                    api.getAdminTestCount(token, res => {
                        // console.log("TC", res.data.count, pageSize);
                        dispatch({
                            type: 'GOT_TABLE_DATA_COUNT',
                            payload: Math.ceil(res.data.count / pageSize)
                        })
                    })
                    break;
            default:
                dispatch({
                    type: 'GOT_TABLE_DATA_COUNT',
                    payload: 0
                })

        }
    }
}

export function setCurrentCourse(course){
    return dispatch => {
        dispatch({
            type: 'SET_CURRENT_ADMIN_COURSE',
            payload: course
        })
    }
}

export function getConsoleInstructors(courseIds, token) {
    return dispatch => {
        api.getConsoleInstructors(courseIds, token, res => {
            if (res.status === 200) {
                dispatch({
                    type: 'GOT_COURSE_INSTRUCTORS',
                    payload: res.data
                })
            }
        })
    }
}

export function getEngagementPage(courseId, userId, token) {
    return dispatch => {
        // console.log("GETTING ENGAGEMENT");
        api.getEngagementPage(courseId, userId, token, res => {
            // console.log("GOT ENGAGEMENT", res);
            if (res.data) {
                dispatch({
                    type: 'GOT_ENGAGEMENT_PAGE',
                    payload: res.data
                })
            }
        })
    }
}

export function getEngagementChart(view, length, courseId, userId, token) {
    return dispatch => {
        dispatch({
            type: 'SET_ENGAGEMENT_CHART_LOADING',
            payload: {view: view, length: length}
        })

        api.getEngagementChart(view, length, courseId, userId, token, res => {
            // console.log("Got chart", res);
            dispatch({
                type: 'SET_ENGAGEMENT_CHART',
                payload: {view: view, data: res.data}
            })
        })
    }
}

export function getCoursesByToken(token, courseId) {
    return dispatch => {
        api.getCoursesByToken(token, res => {
            if (res.status === 200) {
                dispatch({
                    type: 'SET_ADMIN_COURSES',
                    payload: res.data.courses
                })

                if(courseId){
                    res.data.courses.map(c => {
                        if (c.id === courseId){
                            setCurrentCourse(c);
                        }
                    })
                }
            }
        })
    }
}

export function getKpiStats(courseId, token) {
    return dispatch => {
        api.getKpiStats(courseId, token, res => {
            dispatch({
                type: 'GOT_KPI_STATS',
                payload: res.data
            })
        })
    }
}

export function getCountries(length, token) {
    return dispatch => {
        api.getCountryChart(length, token, res => {
            if(res){
                let data = res.data;

                data.plotOptions.map.mapData = map;
                data.tooltip = {
                    backgroundColor: '#901E45',
                    borderWidth: 0,
                    shadow: false,
                    useHTML: true,
                    padding: 10,
                    color: '#fff',
                    formatter: function(){
                        this.y = this.y - 19;
                        // console.log("This y is", this.y);
                        return '<div class="text-white"><span class="f32 text-white"><span class="flag {point.properties.hc-key}">' +
                        '</span></span> {point.name}<br>' +
                        '<span style="font-size:30px">' + Math.abs(this.point.y - 1) + '</span></div>'
                    },
                    positioner: function() {
                      return {
                        x: 0,
                        y: 50,
                      };
                    },
                  }

                dispatch({
                    type: 'GOT_ADMIN_CHART',
                    payload: {
                        view: "countries",
                        data: data,
                        length: length
                    }
                });
            }
        })
    }
}

export function getEngagementStat(name, courseId, token) {
    return dispatch => {
        api.getEngagementStat(name, courseId, token, res => {
            dispatch({
                type: 'GOT_ENGAGEMENT_STAT',
                payload: res.data
            })
        })
    }
}

export function getKPI(view, length, courseId, userId, token){
    return dispatch => {
        dispatch({
            type: 'KPI_LOADING',
            view: view,
            length: length,
            payload: true
        })

        let views = {
            "users": "kpiUsers",
            "sessions": "kpiSessions",
            "videoTime": "kpiVideoTime",
            "messages": "kpiMessages"
        }

        api.getEngagementChart(views[view], length, courseId, userId, token, res => {
            // console.log("Got chart", res);
            dispatch({
                type: 'GOT_KPI_CHART',
                payload: {
                    view: view,
                    data: res.data,
                    length: length
                }
            })
        })
        /*

        api.getKPIChart(view, courseId, length, token, res => {
            if(res){
                dispatch({
                    type: 'GOT_KPI_CHART',
                    payload: {
                        view: view,
                        data: res.data,
                        length: length
                    }
                });
            }
        })

         */
    }
}

export function updateComment(comment, token) {
    return dispatch => {
        api.updateComment(comment, token, res => {
            dispatch({
                type: 'UPDATE_COMMENT',
                payload: res.data
            })
        })
    }
}

export function getComments(skip, courseId, token) {
    return dispatch => {
        dispatch({
            type: 'LOADING_COMMENTS'
        })
        api.getComments(skip, courseId, token, res => {
            if(res.data.status !== 401) {
                dispatch({
                    type: 'GOT_COMMENTS',
                    payload: {
                        skip: skip,
                        ...res.data
                    }
                })
            }
        })
    }
}

export function getViewCounts(token) {
    return dispatch => {
        api.getUserCount(token, res => {
            dispatch({
                type: 'GOT_VIEW_COUNT',
                payload: {
                    view: 'users',
                    count: res.data.count
                }
            })
        })

        api.getSessionCount(token, res => {
            dispatch({
                type: 'GOT_VIEW_COUNT',
                payload: {
                    view: 'sessions',
                    count: res.data.count
                }
            })
        })

        api.getVideoTimeCount('', token, res => {
            dispatch({
                type: 'GOT_VIEW_COUNT',
                payload: {
                    view: 'videoTime',
                    count: res.data.t
                }
            })
        })

        api.getMessageCount(token, res => {
            dispatch({
                type: 'GOT_VIEW_COUNT',
                payload: {
                    view: 'messages',
                    count: res.data.count
                }
            })
        })
    }
}

export function getSortedLeaderboard(courseIds, skip, sort, pageSize, token){
    return dispatch => {
        api.getSortedLeaderboard(courseIds, skip, sort, pageSize, token, res => {
            dispatch({
                type: 'GOT_LEADERBOARD',
                payload: res.data
            })
        })
    }

}

export function getSortedData(view, skip, sort, pageSize, token){
    return dispatch => {
        dispatch({
            type: 'TABLE_LOADING'
        })
        switch(view){
            case 'flags':
                api.getAdminConsoleFlagsSorted(skip, sort, pageSize, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                })
                break;
            case 'lecture_failure':
                api.getAdminConsoleLecturesSorted(skip, sort, pageSize, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'subject_failure':
                api.getAdminConsoleSubjectsSorted(skip, sort, pageSize, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'upcoming_tests':
                api.getAdminConsoleTestsSorted(skip, sort, pageSize, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'attendance':
                api.getAdminConsoleTestsSorted(skip, sort, pageSize, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'quiz_average':
                    api.getAdminConsoleTestsSorted(skip, sort, pageSize, token, res => {
                        dispatch({
                            type: 'GOT_TABLE_DATA',
                            payload: res.data
                        })
                    });
                    break;
            default:
                dispatch({
                    type: 'GOT_TABLE_DATA',
                    payload: []
                })
        }
    }
}

export function saveSearchStudent(cuId, fields, token) {
    return dispatch => {
        dispatch({
            type: 'SEARCH_STUDENT_UPDATED',
            payload: {
                id: cuId,
                fields: fields
            }
        })
        api.saveSearchStudent(cuId, fields, token, res => {
            // console.log("RES", res);
            if (res.status === 200) {
                NotificationManager.success('Student Updated', 'This students information has been saved.');
            } else {
                NotificationManager.error('Student Update Failed', 'Please try resubmitting the student data.');
            }
        })
    }
}


export function loadMoreStudents(courseIds, skip, limit, query, userId, token) {
    return dispatch => {
        let data = {
            ...query,
            skip,
            limit,
            courseIds
        }

        dispatch({
            type: 'SET_LOADING_STUDENTS',
            payload: true
        });

        api.searchStudents(data, userId, token, res => {
            dispatch({
                type: 'APPEND_CONSOLE_STUDENTS',
                payload: res.data
            })
        })
    }
}

export function searchStudents(courseIds, skip, limit, query, userId, token) {
    return dispatch => {
        let data = {
            ...query,
            skip,
            limit,
            courseIds
        }

        api.searchStudents(data, userId, token, res => {
            dispatch({
                type: 'GOT_CONSOLE_STUDENTS',
                payload: res.data
            })
        })
    }
}

export function getStudents(courseIds, skip, limit, filter, userId, token) {
    return dispatch => {
        api.getConsoleStudents(courseIds, skip, limit, filter, userId, token, res => {
            if(res.status === 200) {
                dispatch({
                    type: 'GOT_CONSOLE_STUDENTS',
                    payload: res.data
                })
            }
        })
    }
}

export function addedCuNote(note){
    return dispatch => {
        dispatch({
            type: 'ADDED_CU_NOTE',
            payload: note
        })
    }
}

export function editedCuNote(note){
    return dispatch => {
        dispatch({
            type: 'EDITED_CU_NOTE',
            payload: note
        })
    }
}

export function deletedCuNote(note){
    return dispatch => {
        dispatch({
            type: 'DELETED_CU_NOTE',
            payload: note
        })
    }
}

export function getStudentNotes(cuId, skip, limit, token){
    return dispatch => {
        api.getStudentNotes(cuId, skip, limit, token, res => {
            if(res.status === 200){
                dispatch({
                    type: 'GOT_STUDENT_NOTES',
                    payload: {
                        cuId: cuId,
                        notes: res.data
                    }
                })
            }
        })
    }
}

export function getSingleUserSubject(cuId, subjectId, token){
    return dispatch => {
        api.getSingleUserSubject(cuId, subjectId, token, res => {
            dispatch({
                type: 'GOT_CONSOLE_STUDENT_SUBJECT',
                payload: {
                    cuId: cuId,
                    subject: res.data
                }
            })
        })
    }
}

export function getStudentSubjects(courseIds, token){
    return dispatch => {
        api.getStudentSubjects(courseIds, token, res => {
            dispatch({
                type: 'GOT_STUDENTS_SUBJECTS',
                payload: res.data
            })
        })
    }
}

export function getData(view, skip, limit, token){
    return dispatch => {
        dispatch({
            type: 'TABLE_LOADING'
        })
        switch(view){
            case 'flags':
                api.getAdminConsoleFlags(skip, limit, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'lecture_failure':
                api.getAdminConsoleLectures(skip, limit, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'subject_failure':
                api.getAdminConsoleSubjects(skip, limit, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'upcoming_tests':
                api.getAdminConsoleTests(skip, limit, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'attendance':
                api.getAdminConsoleTests(skip, limit, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            case 'quiz_average':
                api.getAdminConsoleTests(skip, limit, token, res => {
                    dispatch({
                        type: 'GOT_TABLE_DATA',
                        payload: res.data
                    })
                });
                break;
            default:
                dispatch({
                    type: 'GOT_TABLE_DATA',
                    payload: []
                })
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/adminActions.js